import util from '../util'

let controller = 'ContaOperacaoContabil'
export default Object.assign({}, util.GetCrud(controller, null))